export class Checklist {
  constructor({ unidadeId, checklistId, descricao }) {
    this.unidadeId = unidadeId;
    this.checklistId = checklistId;
    this.descricao = descricao;
  }
}
